import { render } from "./FormCheckbox.vue?vue&type=template&id=2abad870&scoped=true&ts=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=ts"
export * from "./FormCheckbox.vue?vue&type=script&lang=ts"

import "./FormCheckbox.vue?vue&type=style&index=0&id=2abad870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abad870"]])

export default __exports__